import * as types from '../mutation-types'
import { api } from '@/modules/api'
import { pathOr } from 'ramda'

const state = {
  totalPages: 0,
  totalItems: 0,
  categories: []
}

const getters = {
  getNominationsCategories: state => state.categories,
  getNominationsTotalPages: state => state.totalPages,
  getNominationsTotalItems: state => state.totalItems
}

const actions = {
  async getNominationsCategoriesList ({commit}, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.nominations.getCategories(payload))
      commit(types.SET_NOMINATIONS_CATEGORIES, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error with loading categories')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createCategory ({commit}, category) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.nominations.postCategory(), {...category})
      commit(types.CREATE_SUCCESS_MESSAGE, 'Category was created successfully')
    } catch (err) {
      if (pathOr('', ['response', 'data', 'Code'], err) === 'validation.base-0001') {
        commit(types.CREATE_ERROR_MESSAGE, `${pathOr('Failed to create new category', ['response', 'data', 'Message'], err)}. ${pathOr('', ['response', 'data', 'ValidationFailures', '0', 'errorMessage'], err)}`)
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Failed to create new category')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateCategory ({commit}, category) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.nominations.putCategory(), {...category})
      commit(types.CREATE_SUCCESS_MESSAGE, 'Category was updated successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error with updating category')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteCategory ({commit}, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.nominations.deleteCategory(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Category was deleted successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error with deleting category')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_NOMINATIONS_CATEGORIES] (state, data) {
    state.categories = data.nominationCategories
    state.totalPages = data.totalPages
    state.totalItems = data.totalItems
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/nominations-categories.js